import { FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
// import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import VendorRiskWrapper from '../pages/vendor/VendorRiskWrapper'
import PersonnelManagementWrapper from '../pages/personnel-management/PersonnelManagementWrapper'
import DataRoomWrapper from '../pages/data-room/DataRoomWrapper'
import AssetManagementWrapper from '../pages/asset-management/AssetManagementWrapper'
import RiskManagementWrapper from '../pages/risk-management/RiskManagementWrapper'
import ReportsWrapper from '../pages/reports/ReportsWrapper'
import PolicyPage from '../pages/policy-management/PolicyPage'
// import AddPolicy from '../modules/apps/policy-management/users-list/components/AddPolicy'
// import Github from '../pages/vendor/applications/Github/Github'
// import {ChatGPT} from '../pages/chat/ChatGPT'
// import Asana from '../pages/vendor/applications/Asana/Asana'
// import Password from '../pages/vendor/applications/1Password/1Password'
// import Discord from '../pages/vendor/applications/Discord/Discord'
// import Notion from '../pages/vendor/applications/Notion/Notion'
// import GoogleSuite from '../pages/vendor/applications/GoogleSuite/GoogleSuite'
// import Jira from '../pages/vendor/applications/Jira/Jira'
// import Zoom from '../pages/vendor/applications/Zoom/Zoom'
// import Slack from '../pages/vendor/applications/Slack/Slack'
// import MicrosoftTeam from '../pages/vendor/applications/MicrosoftTeam/MicrosoftTeam'
import ControlManagementWrapper from '../pages/controls/ControlManagementWrapper'
// import {Requirements} from '../pages/controlInformation/Requirements'
// import {Testing} from '../pages/controlInformation/Testing'
import TestManagementWrapper from '../pages/tests/TestManagementWrapper'
// import PasswordDocuments from '../pages/vendor/applications/1Password/PasswordDocuments'
// import AsanaDocuments from '../pages/vendor/applications/Asana/AsanaDocuments'
// import DiscordDocuments from '../pages/vendor/applications/Discord/DiscordDocuments'
// import NotionDocuments from '../pages/vendor/applications/Notion/NotionDocuments'
// import GoogleDocuments from '../pages/vendor/applications/GoogleSuite/GoogleDocuments'
// import JiraDocuments from '../pages/vendor/applications/Jira/JiraDocuments'
// import SlackDocuments from '../pages/vendor/applications/Slack/SlackDocuments'
// import MicrosoftDocuments from '../pages/vendor/applications/MicrosoftTeam/MicrosoftDocuments'
// import GithubDocuments from '../pages/vendor/applications/Github/GithubDocument'
// import Dropbox from '../pages/vendor/applications/Dropbox/Dropbox'
// import DropboxDocuments from '../pages/vendor/applications/Dropbox/DropboxDocuments'
// import Figma from '../pages/vendor/applications/Figma/Figma'
// import DocuSign from '../pages/vendor/applications/DocuSign/DocuSign'
// import PandaDoc from '../pages/vendor/applications/PandaDoc/PandaDoc'
// import PandaDocuments from '../pages/vendor/applications/PandaDoc/PandaDocuments'
// import TypeForm from '../pages/vendor/applications/TypeForm/TypeForm'
// import TypeFormDocuments from '../pages/vendor/applications/TypeForm/TypeFormDocuments'
// import ZoomDocuments from '../pages/vendor/applications/Zoom/ZoomDocuments'
// import {Available} from '../pages/vendor/tab-menu-list/Available'
import {Archive} from '../pages/vendor/tab-menu-list/Archive'
// import AddVendor from '../pages/vendor/components/AddVendor'
// import EditVendor from '../pages/vendor/components/EditVendor'
import DetailVendor from '../pages/vendor/components/DetailVendor'
// import FigmaDocuments from '../pages/vendor/applications/Figma/FigmaDocuments'
// import {ControlInformationManagement} from '../pages/controlInformation/ControlInformationManagement'
// import RiskDetailsWrapper from '../pages/risk-management-details/RiskDetailsWrapper'
// import CompleteAssessmentWrapper from '../pages/risk-management-details/CompleteAssesmentWrapper'
// import TestDetailsWrapper from '../pages/test-details/TestDetailsWrapper'
import {TrainingPage} from '../onboarding/onDashBoard/Training'
import Policies from '../onboarding/onDashBoard/Policies'
import BackgroundCheck from '../onboarding/onDashBoard/BackgroundCheck'
// import {PolicyTemplates} from '../pages/policy-management/tab-menu-list/PolicyTemplates'
import PersonnelGroup from '../pages/personnel-management/tab-menu-list/PersonnelGroup'
import PersonnelChecklist from '../pages/personnel-management/tab-menu-list/PersonnelChecklist'
import SettingPage from '../pages/settings/SettingPage'
import SettingAdvanced from '../pages/settings/tab-menu-list/SettingAdvanced'
import SettingFramework from '../pages/settings/tab-menu-list/SettingFramework'
// import SettingSecurity from '../pages/settings/tab-menu-list/SettingSecurity'
// import SettingLanguage from '../pages/settings/tab-menu-list/SettingLanguage'
// import SettingRoles from '../pages/settings/tab-menu-list/SettingRoles'
// import RolePermissiondetails from '../pages/settings/sub-tab-menu-list/RolePermissiondetails'
import SettingsUserpermissions from '../pages/settings/tab-menu-list/SettingsUserpermissions'
import UserAuditors from '../pages/settings/sub-tab-menu-list/UserAuditors'
// import AddControl from '../pages/controls/components/AddControl'
// import CloudRiskWrapper from '../pages/Clouds/CloudRiskWrapper'
// import {Checks} from '../pages/Clouds/tab-menu-list/Checks'
// import {Containers} from '../pages/Clouds/tab-menu-list/Containers'
// import {Assets} from '../pages/Clouds/tab-menu-list/Assets'
// import DomainWrapper from '../pages/Domains/DomainWrapper'
// import {DomainChecks} from '../pages/Domains/tab-menu-list/DomainChecks'
import DetailControl from '../pages/controls/components/DetailControl'
import DetailsTest from '../pages/tests/components/DetailsTest'
import ViewReports from '../pages/reports/components/ViewReports'
import {RiskLibrary} from '../pages/risk-management/components/tab-menu/RiskLibrary'
import RiskOverview from '../pages/risk-management/components/tab-menu/RiskOverview'
// import IntegrationForm from '../pages/integrations/components/IntegrationForm'
import SettingsCompany from '../pages/settings/tab-menu-list/SettingsCompany'
// import CloudsAWSWrapper from '../pages/Clouds-link/CloudsAWSWrapper'
import {useAuth} from '../modules/auth'
import ViewVendor from '../pages/vendor/components/ViewVendor'
import Diligence from '../pages/vendor/components/subcomponents/Diligence'
import ReportPageWrapper from '../pages/report-page/ReportPageWrapper'
// import TaskManagementWrapper from '../pages/tasks/TaskManagementWrapper'
import {AssetRepository} from '../pages/asset-management/components/tab-menu/AssetRepository'
import ActivityLog from '../pages/report-page/pages/ActivityLog'
import SOCReports from '../pages/reports/components/SOCReports'
import AuditWrapper from '../pages/audit/AuditWrapper'
import AuditComplete from 'app/pages/audit/tab-menu/AuditComplete'
// import Availabe from '../pages/integrations/components/tabs/Availabe'
import IntegrationWrapper from '../pages/integrations/IntegrationWrapper'
import TrustWrapper from 'app/pages/trust/TrustWrapper'
import GDPRReports from 'app/pages/reports/components/GDPRReports'
import HIPAAReports from 'app/pages/reports/components/HIPAAReports'
import {TrialOnboardingPage} from 'app/pages/Trial-onboarding/pages/TrialOnboardingPage'
import PublishedTrustCenter from 'app/pages/trust/PublishedTrustCenter'
import ErrorBoundary from 'app/onboarding/cores/ErrorBoundary'
import VulnerabilityWrapper from 'app/pages/vulnerabilities/VulnerabilityWrapper'
import SettingsCookie from 'app/pages/settings/tab-menu-list/SettingsCookie'
import TrainingViewer from 'app/onboarding/components/TrainingViewer'
import CloudRiskWrapper from 'app/pages/Clouds/CloudRiskWrapper'
import CloudDetailLayout from 'app/pages/Clouds/components/CloudDetailLayout'
import {Checks} from 'app/pages/Clouds/tab-menu-list/Checks'
import {Assets} from 'app/pages/Clouds/tab-menu-list/Assets'
import CloudConfiguration from 'app/pages/Clouds/pages/GCP/CloudConfiguration'
import DomainWrapper from 'app/pages/Domains/DomainWrapper'
import {DomainChecks} from 'app/pages/Domains/tab-menu-list/DomainChecks'
import AccessReviewWrapper from 'app/pages/user-access/AccessReviewWrapper'
import { ReviewPage } from 'app/pages/user-access/tabs/ReviewPage'
import VendorReviewDetails from 'app/pages/user-access/pages/VendorReviewDetails'
import SystemDetails from 'app/pages/user-access/pages/SystemDetails'
import AccessChange from 'app/pages/user-access/tabs/AccessChange'
import SettingSecurity from 'app/pages/settings/tab-menu-list/SettingSecurity'
import RoleProtectedRoute from './RoleProtectedRoute'
import IntegrationAvailabe from 'app/pages/integrations/components/tabs/IntegrationAvailable'
import AssetDomain from 'app/pages/asset-management/components/tab-menu/AssetDomain'

const PrivateRoutes = () => {
  const {currentUser} = useAuth()

  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  // const PolicyPage = lazy(() => import('../modules/apps/policy-management/PolicyPage'))
  const isOnboardingComplete = currentUser?.onboardingComplete || false
  const isNewUser = currentUser?.isNewUser || false
  const isTrustUser = currentUser?.account_type === 'trust'
  const isNewClient = currentUser?.isNewClient || false

  return (
    <Routes>
      <Route
        path='trial'
        element={
          isTrustUser ? (
            <Navigate to={'/trust-center'} />
          ) :isNewClient? (
            <Navigate to='/loading' />
          ) : isNewUser && !isOnboardingComplete ? (
            <Navigate to='/onboarding' />
          ) : (
            <Navigate to='/dashboard' />
          )
        }
      />
      <Route
        path='onboarding'
        element={
          isTrustUser ? (
            <Navigate to={'/trust-center'} />
          ) : isOnboardingComplete ? (
            <Navigate to='/dashboard' />
          ) : (
            <TrialOnboardingPage />
          )
        }
      />
      <Route path='/trust/:companyId' element={<PublishedTrustCenter />} />
      <Route path='/trust/:companyId/controls' element={<PublishedTrustCenter />} />
      <Route path='/trust/:companyId/resources' element={<PublishedTrustCenter />} />
      <Route path='/trust/:companyId/subprocessors' element={<PublishedTrustCenter />} />
      <Route path='/trust/:companyId/faq' element={<PublishedTrustCenter />} />

      <Route element={<MasterLayout />}>
        {isTrustUser ? (
          <>
            <Route path='company-settings' element={<SettingPage />} />
            <Route path='company-settings/company_info' element={<SettingsCompany />} />

            <Route path='/trust-center' element={<TrustWrapper />} />
            <Route path='/trust-center/requests' element={<TrustWrapper />} />
            <Route path='/trust-center/updates' element={<TrustWrapper />} />
            <Route path='/trust-center/settings' element={<TrustWrapper />} />
            <Route path='/trust-center/registration' element={<Navigate to={'/trust-center'} />} />
            <Route path='/auth/*' element={<Navigate to={'/trust-center'} />} />
            <Route path='*' element={<Navigate to={'/error/404'} />} />
          </>
        ) : (
          <>
            {/* Redirect to Dashboard after success login/registartion */}
            {currentUser?.role === 'Member' ? (
              <Route path='/*' element={<Navigate to='/training' />} />
            ) : (
              <>
                {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} />
            <Route path='dashboard' element={<DashboardWrapper />} />
            <Route path='builder' element={<BuilderPageWrapper />} /> */}

                <Route
                  path='auth/*'
                  element={
                    isNewClient ? (
                      <Navigate to='/loading' />
                    ) : isNewUser && !isOnboardingComplete ? (
                      <Navigate to='/onboarding' />
                    ) : (
                      <Navigate to='/dashboard' />
                    )
                  }
                />
                <Route
                  path='dashboard'
                  element={
                    isNewUser && !isOnboardingComplete ? (
                      <Navigate to='/onboarding' />
                    ) : (
                      <DashboardWrapper />
                    )
                  }
                />
                <Route
                  path='builder'
                  element={
                    isNewUser && !isOnboardingComplete ? (
                      <Navigate to='/onboarding' />
                    ) : (
                      <BuilderPageWrapper />
                    )
                  }
                />

                <Route
                  path='policy-library/*'
                  element={
                    <SuspensedView>
                      <PolicyPage />
                    </SuspensedView>
                  }
                />
                {/* Settings-start */}
                <Route path='company-settings' element={<SettingPage />} />
                <Route path='company-settings/advanced' element={<SettingAdvanced />} />
                <Route path='company-settings/framework' element={<SettingFramework />} />
                <Route path='company-settings/company_info' element={<SettingsCompany />} />
                <Route path='company-settings/users' element={<SettingsUserpermissions />} />
                <Route path='company-settings/users/auditors' element={<UserAuditors />} />
                <Route path='company-settings/cookie-widget' element={<SettingsCookie />} />
               <Route path='company-settings/security' element={<SettingSecurity/>} /> 
                {/* Settings-end */}

                <Route path='policy-library/*' element={<PolicyPage />} />
                {/* <Route path='/policy-library/PolicyTemplates' element={<PolicyTemplates />} /> */}
                <Route path='vendor-risk' element={<VendorRiskWrapper />} />
                <Route path='vendor-risk/details/:id' element={<ViewVendor />} />
                <Route path='vendor-risk/details/diligence/:id' element={<Diligence />} />
                <Route path='/vendor-risk/archive' element={<Archive />} />
                <Route path='vendor-management/detail-vendor/:id' element={<DetailVendor />} />

                <Route path='employees' element={<PersonnelManagementWrapper />} />
                <Route path='employees/group' element={<PersonnelGroup />} />
                <Route path='/employees/checklist' element={<PersonnelChecklist />} />

                <Route path='data-room' element={<DataRoomWrapper />} />

                <Route path='asset-management' element={<AssetManagementWrapper />} />
                <Route path='asset-management/repositories' element={<AssetRepository />} />
                <Route path='asset-management/domains' element={<AssetDomain />} />
                <Route
                  path='integrations'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner','Admin']} allowedAccountTypes={['internal','Trial-plus']}>
                      <IntegrationWrapper />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path='integrations/available'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner','Admin']} allowedAccountTypes={['internal','Trial-plus']}>
                      <IntegrationAvailabe />
                    </RoleProtectedRoute>
                  }
                />

                {/* <Route path='integrations/form' element={<IntegrationForm />} /> //{for adding integration use this route} */}
                {/* <Route path='menu-test' element={<MenuTestPage />} /> */}
                {/* <Route path='asset-management/add-asset' element={<AddAsset />} /> */}

                <Route path='risk-management' element={<RiskManagementWrapper />} />
                <Route path='risk-management/library' element={<RiskLibrary />} />
                <Route path='risk-management/overview' element={<RiskOverview />} />
                <Route path='risk-management/:id' element={<RiskManagementWrapper />} />

                <Route path='audits' element={<AuditWrapper />} />
                <Route path='audits/completed' element={<AuditComplete />} />

                <Route path='/controls' element={<ControlManagementWrapper />} />
                <Route path='/controls/details/:id' element={<DetailControl />} />

                <Route path='/tests' element={<TestManagementWrapper />} />
                <Route path='/tests/details/:id' element={<DetailsTest />} />

                <Route path='/frameworks' element={<ReportsWrapper />} />
                <Route path='/frameworks/details/:name' element={<ViewReports />} />
                <Route path='/frameworks/details/SOC_2' element={<SOCReports />} />
                <Route path='/frameworks/details/GDPR' element={<GDPRReports />} />
                <Route path='/frameworks/details/HIPAA' element={<HIPAAReports />} />

                <Route path='/reports' element={<ReportPageWrapper />} />
                <Route path='/reports/activity-logs' element={<ActivityLog />} />
                {/* <Route path='vendor-management/add-vendor' element={<AddVendor />} /> */}
                {/* <Route path='vendor-management/edit-vendor/:id' element={<EditVendor />} /> */}
                {/* <Route path='/vendor-risk/archive/:id' element={<DetailVendor />} /> */}
                {/* <Route path='vendor-risk/github/details' element={<Github />} />
                <Route path='vendor-risk/asana/details' element={<Asana />} />
                <Route path='vendor-risk/password/details' element={<Password />} />
                <Route path='vendor-risk/discord/details' element={<Discord />} />
                <Route path='vendor-risk/notion/details' element={<Notion />} />
                <Route path='vendor-risk/google-suite/details' element={<GoogleSuite />} />
                <Route path='vendor-risk/atlassian-jira/details' element={<Jira />} />
                <Route path='vendor-risk/zoom/details' element={<Zoom />} />
                <Route path='vendor-risk/slack/details' element={<Slack />} />
                <Route path='vendor-risk/microsoft-team/details' element={<MicrosoftTeam />} />
                <Route path='vendor-risk/dropbox/details' element={<Dropbox />} />
                <Route path='vendor-risk/figma/details' element={<Figma />} />
                <Route path='vendor-risk/docusign/details' element={<DocuSign />} />
                <Route path='vendor-risk/panda-doc/details' element={<PandaDoc />} />
                <Route path='vendor-risk/type-form/details' element={<TypeForm />} /> */}
                {/* <Route path='/vendor-risk/password/documents' element={<PasswordDocuments />} />
                <Route path='/vendor-risk/asana/documents' element={<AsanaDocuments />} />
                <Route path='/vendor-risk/discord/documents' element={<DiscordDocuments />} />
                <Route path='/vendor-risk/notion/documents' element={<NotionDocuments />} />
                <Route path='/vendor-risk/google-suite/documents' element={<GoogleDocuments />} />
                <Route path='/vendor-risk/atlassian-jira/documents' element={<JiraDocuments />} />
                <Route path='/vendor-risk/google-suite/documents' element={<NotionDocuments />} />
                <Route path='/vendor-risk/slack/documents' element={<SlackDocuments />} />
                <Route
                  path='/vendor-risk/microsoft-team/documents'
                  element={<MicrosoftDocuments />}
                />
                <Route path='/vendor-risk/github/documents' element={<GithubDocuments />} />
                <Route path='/vendor-risk/dropbox/documents' element={<DropboxDocuments />} />
                <Route path='/vendor-risk/panda-doc/documents' element={<PandaDocuments />} />
                <Route path='/vendor-risk/type-form/documents' element={<TypeFormDocuments />} />
                <Route path='/vendor-risk/zoom/documents' element={<ZoomDocuments />} />
                <Route path='/vendor-risk/figma/documents' element={<FigmaDocuments />} /> */}
                {/* <Route path='/vendor-risk/available' element={<Available />} /> */}             
                {/* <Route path='/tasks' element={<TaskManagementWrapper />} /> */}
                {/* <Route path='/controls/addControls' element={<AddControl />} /> */}

                <Route path='vulnerabilities/clouds' element={<CloudRiskWrapper />} />
                <Route path='vulnerabilities/clouds/:id' element={<CloudDetailLayout />} />
                <Route path='vulnerabilities/clouds/:id/assets' element={<CloudDetailLayout />} />
                <Route path='vulnerabilities/clouds/:id/containers' element={<CloudDetailLayout />} />
                <Route path='vulnerabilities/clouds/:id/checks' element={<CloudDetailLayout />} />
                <Route path='vulnerabilities/clouds/checks' element={<Checks />} />
                <Route path='vulnerabilities/clouds/assets' element={<Assets />} />
                <Route path='vulnerabilities/clouds/gcp/configuration' element={<CloudConfiguration />} />
                <Route path='vulnerabilities/domains' element={<DomainWrapper />} />
                <Route path='vulnerabilities/domains/checks' element={<DomainChecks />} />
                <Route
                  path='vulnerabilities/assets'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner','Admin']} allowedAccountTypes={['internal','Trial-plus']}>
                      <VulnerabilityWrapper />
                    </RoleProtectedRoute>
                  }
                />
                <Route path='/trust-center' element={<TrustWrapper />} />
                <Route path='/trust-center/requests' element={<TrustWrapper />} />
                <Route path='/trust-center/updates' element={<TrustWrapper />} />
                <Route path='/trust-center/settings' element={<TrustWrapper />} />
                
                

                <Route
                  path='/access'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner', 'Admin']} allowedAccountTypes={['internal']}>
                      <AccessReviewWrapper />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path='/access/review'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner', 'Admin']} allowedAccountTypes={['internal']}>
                      <ReviewPage />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path='/access/review/:id'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner', 'Admin']} allowedAccountTypes={['internal']}>
                      <VendorReviewDetails />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path='/access/review/:id/system/:systemId'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner', 'Admin']} allowedAccountTypes={['internal']}>
                      <SystemDetails />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path='/access/review/:id/access-changes'
                  element={
                    <RoleProtectedRoute allowedRoles={['Owner', 'Admin']} allowedAccountTypes={['internal']}>
                      <AccessChange />
                    </RoleProtectedRoute>
                  }
                />


                {/* <Route
                  path='/controls/:id/requirements'
                  element={
                    <SuspensedView>
                      <Requirements />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/controls/:id/details'
                  element={
                    <SuspensedView>
                      <ControlInformationManagement />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/controls/:id/testing'
                  element={
                    <SuspensedView>
                      <Testing />
                    </SuspensedView>
                  }
                /> */}
                {/* <Route
                  path='/risk-management/:id/details'
                  element={
                    <SuspensedView>
                      <RiskDetailsWrapper />
                    </SuspensedView>
                  }
                /> */}
                {/* <Route
                  path='/tests/:id/details'
                  element={
                    <SuspensedView>
                      <TestDetailsWrapper />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/tests/:id/details/overview'
                  element={
                    <SuspensedView>
                      <TestDetailsWrapper />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/tests/:id/details'
                  element={
                    <SuspensedView>
                      <TestDetailsWrapper />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/tests/:id/details'
                  element={
                    <SuspensedView>
                      <TestDetailsWrapper />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/tests/:id/details'
                  element={
                    <SuspensedView>
                      <TestDetailsWrapper />
                    </SuspensedView>
                  }
                /> */}
                {/* <Route
                  path='/risk-management/:id/details/complete-assessment'
                  element={
                    <SuspensedView>
                      <CompleteAssessmentWrapper />
                    </SuspensedView>
                  }
                />
                <Route
                  path='/risk-management/:id/history'
                  element={
                    <SuspensedView>
                      <Testing />
                    </SuspensedView>
                  }
                /> */}
                {/* <Route path='/chatgpt' element={<ChatGPT />} /> */}
                {/* Lazy Modules */}
                {/* <Route
                  path='crafted/pages/profile/*'
                  element={
                    <SuspensedView>
                      <ProfilePage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='crafted/pages/wizards/*'
                  element={
                    <SuspensedView>
                      <WizardsPage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='crafted/widgets/*'
                  element={
                    <SuspensedView>
                      <WidgetsPage />
                    </SuspensedView>
                  }
                />

                <Route
                  path='apps/chat/*'
                  element={
                    <SuspensedView>
                      <ChatPage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='apps/user-management/*'
                  element={
                    <SuspensedView>
                      <UsersPage />
                    </SuspensedView>
                  }
                /> */}
              </>
            )}

            {/* <Route
              path='crafted/account/*'
              element={
                <SuspensedView>
                  <AccountPage />
                </SuspensedView>
              }
            /> */}
            <Route path='training' element={<TrainingPage completed={false} />} />
            <Route
              path='policies'
              element={
                <ErrorBoundary>
                  <Policies />
                </ErrorBoundary>
              }
            />
            <Route path='backgroundCheck' element={<BackgroundCheck />} />
            {/* comp0nents in training */}
            <Route path='training/SAT' element={<TrainingViewer />} />
            {/* <Route path='training/HIPAA' element={<TrainingViewer />} /> */}
            <Route path='training/GDPR' element={<TrainingViewer />} />
            {/* end */}
            {/* Page Not Found */}
            <Route path='*' element={<Navigate to='/error/404' />} />
          </>
        )}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
